import { cn } from 'src/lib/utils';

const Header = ({ className }: { className?: string }) => {
  return (
    <div className={cn('space-y-1 mb-6', className)}>
      <div className="text-base font-semibold text-gray-700">Reports</div>
      <p className="text-sm text-gray-500">Reports are part of our Verified and Certified Verification Add-Ons.</p>
    </div>
  );
};

export default Header;
